import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Update and create block visibility criteria
 * @param {showcaseBlockId} string required
 * @param {data} object required
 */
export async function updateBlockCriteria(projectId, showcaseBlockId, data) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/block-criteria/${projectId}/showcase-blocks/${showcaseBlockId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }
    );
    return await response.json();
}

/**
 * Get block visibility criteria
 * @param {showcaseBlockId} string required
 */
export async function getBlockCriteria(projectId, showcaseBlockId) {
    const user = store?.getState()?.user;

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/block-criteria/${projectId}/showcase-blocks/${showcaseBlockId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
}
/**
 * delete block visibility criteria by id
 * @param {showcaseBlockId} string required
 */
export async function deleteBlockCriteria(projectId, showcaseBlockId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/block-criteria/${projectId}/showcase-blocks/${showcaseBlockId}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}

/**
 * Update and create pages visibility criteria
 * @param {showcaseBlockId} string required
 * @param {data} object required
 */
export async function updatePageCriteria(projectId, showcaseBlockId, data) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcase-criteria/${projectId}/showcases/${showcaseBlockId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }
    );
    return await response.json();
}

/**
 * Get pages visibility criteria
 * @param {showcaseBlockId} string required
 */
export async function getPageCriteria(projectId, showcaseBlockId) {
    const user = store?.getState()?.user;

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcase-criteria/${projectId}/showcases/${showcaseBlockId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
}
/**
 * delete pages visibility criteria by id
 * @param {showcaseBlockId} string required
 */
export async function deletePageCriteria(projectId, showcaseBlockId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/showcase-criteria/${projectId}/showcases/${showcaseBlockId}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}
